import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export async function addToWaitlist(email) {
  try {
    const waitlistRef = collection(db, 'waitlist');
    await addDoc(waitlistRef, {
      email,
      timestamp: new Date()
    });
    return true;
  } catch (error) {
    console.error('Error adding to waitlist:', error);
    throw error;
  }
} 